export default "__VITE_ASSET__CGVDerhR__"